import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors, typography } from '../constants';

const SURFACES = {
  info: { bg: colors.accent, fg: colors.accentForeground },
  success: { bg: colors.successSurface, fg: colors.successSurfaceForeground },
  warning: { bg: colors.warningSurface, fg: colors.warningSurfaceForeground },
  error: {
    bg: colors.destructiveSurface,
    fg: colors.destructiveSurfaceForeground,
  },
};

/** Tinted note box used for tips, suggestions and save failures. */
export default function Banner({ tone = 'info', children, action, sx }) {
  const surface = SURFACES[tone] ?? SURFACES.info;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1.5,
        backgroundColor: surface.bg,
        borderRadius: 2,
        px: 1.5,
        py: 1.25,
        ...sx,
      }}
    >
      <Typography
        sx={{
          fontSize: typography.caption,
          color: surface.fg,
          lineHeight: 1.45,
        }}
      >
        {children}
      </Typography>
      {action}
    </Box>
  );
}
